import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MfaPhoneNumberForm from '../components/MfaPhoneNumberForm';
import {
  getAlphabeticalCountries,
  getCurrentLocation,
  getCurrentPhoneCode,
} from 'modules/geolocation/selectors';
import { getCountriesAction, getCountryByIpRequest } from 'modules/geolocation/actions';
import PropTypes from 'prop-types';
import { change } from 'redux-form';

const MfaPhoneNumberFormContainer = ({ form }) => {
  const dispatch = useDispatch();
  const alphabeticalCountries = useSelector(getAlphabeticalCountries);
  const currentPhoneCode = useSelector(getCurrentPhoneCode);
  const currentLocation = useSelector(getCurrentLocation);

  useEffect(() => {
    dispatch(getCountriesAction());
    dispatch(getCountryByIpRequest());
  }, [dispatch]);

  useEffect(() => {
    if (currentPhoneCode) {
      dispatch(
        change(form, 'phoneInfo', {
          phoneCountry: currentLocation.name,
          phoneNumber: currentPhoneCode,
        }),
      );
    }
  }, [dispatch, form, currentPhoneCode, currentLocation]);

  return <MfaPhoneNumberForm alphabeticalCountries={alphabeticalCountries} />;
};

MfaPhoneNumberFormContainer.propTypes = {
  form: PropTypes.string.isRequired,
};

export default MfaPhoneNumberFormContainer;
